<template>
    <div class="main">
    <div class="banner" 
        >
        <navComponent :activeName="activeName"></navComponent>
        <aboutUsBanner></aboutUsBanner>
    </div>
    <aboutUs></aboutUs>
    <footerComponent></footerComponent>
</div>
</template>
<script>
import aboutUsBanner from '/components/pc/headerComponent/aboutUsBanner.vue'
import aboutUs from '/components/pc/aboutUs/aboutUs.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default {
  components:{
    aboutUsBanner,
    aboutUs,
    footerComponent,
    navComponent,
  },
    data() {
      return {
          activeName: 'fourth',
          // isNavScroll:false,
      };
    },
     mounted(){
      // window.addEventListener('scroll', () => {
      //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
      //   if (scrollTop > 88) {
      //     this.isNavScroll = true
      //   } else {
      //     this.isNavScroll = false
      //   }
      // });
    },
    methods: {
    }
  };
</script>
<style scoped lang="scss">
 .main {
    width: 100%;
    .banner {
        width: 100%;
    }
}
</style>